import styled from "styled-components";


export const StyledInputDate = styled.input`
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.line};
    padding: 0.5rem;
    outline: none;
    padding-bottom: 8px;
    width: 8%;
    width: 100%;
    background: transparent;
    color: ${(props) => props.theme.colors.body};

    input:focus {
      border: none;
    }
    
    input:active {
      border: none;
    }

    ::placeholder {
      color: ${(props) => props.theme.colors.placeholder};
    }

`;